import React from 'react';
import styled from 'styled-components';

import ShareIcon from './ShareIcon.svg'
import { Translation } from 'react-i18next';
import { withTranslation } from 'react-i18next';

const buttonStyle = {
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#5b7e2d',
    textDecoration: 'underline'
}

const buttonImageStyle = {
    paddingLeft: '5px'
}

const copyURL = () => {

    const KEY_MAPZOOM = 'MAPZOOM';
    const savedZoomState = localStorage.getItem(KEY_MAPZOOM);
    const path = window.location.href + '&utm_source=website&utm_medium=WIN_website&utm_campaign=MAP_SHARE';
    const share_url = (savedZoomState && typeof savedZoomState !== 'undefined') ? path + '&zoom=' + savedZoomState : path;

    let dummy = document.createElement('input'),
        text = share_url;
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    window.toastr.success('Link Copied');
}


const ShareSearch = ({ t, i18n }) => (
    <React.Fragment>
        <button onClick={copyURL} style={buttonStyle}>
            {t('Copy.Link')}
            <img src={ShareIcon} style={buttonImageStyle}/>
        </button>
    </React.Fragment>
);

export default withTranslation()(ShareSearch);
